<template>
  <div style="position:absolute;top:0;left:0;right:0;bottom:0;" class="layout-column">
    <div class="layout-column flex ma-2 elevation-5"
         style="border-radius:4px;position:relative;"
         v-bind:style="{background: compColor.contentFrame}">

      <ValidationObserver ref="CompanyDetailForm" v-slot="{ valid, pristine, reset }" class="layout-column flex">
        <div v-bind:style="{'z-index': '4'}" class="layout-row layout-align-center-center pa-1" v-if="!companyId">
          <div class="layout-row">
            <lx-btn small classes="mr-1" :disabled="pristine"
                    @click="clearForm(reset)"
                    icon="mdi-undo-variant" tooltip="Änderungen an der Firma zurücksetzen" label="Zurücksetzen"
                    :hide-label="true"></lx-btn>
            <lx-btn small classes="mr-1" :disabled="!valid || pristine"
                    @click="saveCompanyData"
                    icon="save" tooltip="Änderungen an der Firma speichern" label="Speichern"
                    :hide-label="true"></lx-btn>
          </div>
          <div class="flex layout-row"></div>
        </div>

        <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

        <div class="flex layout-column pa-2" style="overflow-y: auto;">
          <v-progress-linear :indeterminate="loading" v-if="loading" color="red accent-2"
                             background-color="red lighten-4" class="ma-0"
                             style="border-radius:0;height:4px;position: absolute;top:56px;left:0; width:100%;"></v-progress-linear>

          <lx-expansion-panels :single-open="false" v-model="panel">
            <lx-expansion-panel :disabled="true">
              <lx-expansion-panel-header icon="mdi-account-circle"
                                         :disabled="true"
                                         :main-headline="$t('COMPONENT_ACCOUNT.HEADER')"
                                         :sub-headline="$t('COMPONENT_ACCOUNT.BASE_DATA_SUB_LINE')">
              </lx-expansion-panel-header>
              <lx-expansion-panel-content>
                <div class="pa-4 layout-row layout-wrap">
                  <div class="layout-row layout-wrap flex-100">
                    <div class="flex-gt-sm-50 flex-100 px-2">
                      <validation-provider tag="div" ref="email" name="email"
                                           rules="required|email"
                                           v-slot="{ errors }">
                        <v-text-field
                            :dark="compColor.isInDarkMode"
                            v-model="model.email"
                            :label="$t('COMPONENT_ACCOUNT.EMAIL')"
                            :hint="$t('COMPONENT_USER_DETAILS.CHECK_MAIL_HINT')"
                            :color="compColor.isInDarkMode ? compColor.primeHighlightColor : compColor.primeColor"
                            :disabled="!!companyId"
                            :error-messages="errors[0]"
                            :dense="denseFields"
                            :persistent-hint="!companyId"
                            outlined
                        ></v-text-field>
                      </validation-provider>
                    </div>

                    <!-- Button to check mail of new user, will not be shown when existing user  -->

                    <lx-btn :dark="compColor.isInDarkMode" class="white--text text-none ml-2 pa-5" :color="compColor.primeColor"
                            :disabled="!model.email || isMailInvalid"
                            v-if="!companyId"
                            :height="denseFields ? 40 : 48"
                            :width="300"
                            @click="checkEmail"
                            style="height: 72%;"
                            :label="$t('buttons.check_email.title')">
                      <v-icon left dark>search</v-icon>
                      <span>{{ $t('buttons.check_email.value') }}</span>
                    </lx-btn>
                  </div>

                  <!-- alert when recent auth user (email exists at lx-auth), only when new user -->

                  <div v-show="!companyId && authUserExists && !localUserExists" class="ml-2 pt-4 flex-100">
                    <div class="layout-row wrap">
                      <div class="flex xs12">
                        <v-alert :value="true" color="orange" class="ma-0 px-1 py-3 report" style="border: none;">
                          <div class="layout-row layout-align-start-center">
                            <v-avatar color="orange lighten-1" class="mx-2">
                              <v-icon color="orange darken-3" large>warning</v-icon>
                            </v-avatar>

                            <div class="layout-column">
                              <span>{{ $t('COMPONENT_USER_DETAILS.AUTH_PHYSICIAN_ALREADY_EXISTS') }}</span>
                              <span style="font-weight: bold;">{{ $t('COMPONENT_USER_DETAILS.AUTH_USER_ALREADY_EXISTS_HINT') }}</span>
                            </div>

                            <div class="flex"></div>
                            <v-btn color="orange darken-3" depressed class="white--text mx-3" @click="addCompany">
                              <span>{{ $t('buttons.add_physician.value') }}</span>
                            </v-btn>
                          </div>
                        </v-alert>
                      </div>
                    </div>
                  </div>

                  <!-- alert when recent auth & local user (email exists at lx-auth & local), only when new user -->

                  <div v-show="!companyId && localUserExists" class="ml-2 pt-4 flex-100">
                    <div class="layout-row wrap">
                      <div class="flex xs12">
                        <v-alert :value="true" color="red" class="ma-0 px-1 py-3 report" style="border: none;">
                          <div class="layout-row layout-align-start-center">
                            <v-avatar color="red lighten-1" class="mx-2">
                              <v-icon color="red darken-3" large>warning</v-icon>
                            </v-avatar>

                            <div class="layout-column">
                              <span>{{ $t('COMPONENT_USER_DETAILS.LOCAL_USER_ALREADY_EXISTS') }}</span>
                            </div>
                          </div>
                        </v-alert>
                      </div>
                    </div>
                  </div>

                  <!-- new user (email NOT exists at lx-auth) or existing user with disabled fields-->

                  <v-divider v-bind:style="{'border-color':compColor.lightDivider}" class="mx-3 my-6" v-show="companyId || (authUserExists === false && localUserExists === false && model.email)"></v-divider>

                  <div v-show="companyId || (authUserExists === false && localUserExists === false && model.email)" class="layout-row layout-wrap flex-100 mt-6">

                    <!-- firstname -->

                    <div class="flex-gt-sm-50 flex-100 px-2">
                      <validation-provider tag="div" name="firstname" rules="required|min:2" v-slot="{ errors }">
                        <v-text-field
                            :dark="compColor.isInDarkMode"
                            :color="compColor.primeColor"
                            :dense="denseFields"
                            :label="$t('COMPONENT_ACCOUNT.FIRSTNAME') + ' *'"
                            outlined
                            :hide-details="!errors || errors.length <= 0"
                            :disabled="!!companyId"
                            :error-messages="errors[0]"
                            v-model="model.firstname"
                        ></v-text-field>
                      </validation-provider>
                    </div>

                    <!-- lastname -->

                    <div class="flex-gt-sm-50 flex-100 px-2">
                      <validation-provider tag="div" name="lastname" rules="required|min:2" v-slot="{ errors }">
                        <v-text-field
                            :dark="compColor.isInDarkMode"
                            :color="compColor.primeColor"
                            :dense="denseFields"
                            :label="$t('COMPONENT_ACCOUNT.LASTNAME') + ' *'"
                            outlined
                            :hide-details="!errors || errors.length <= 0"
                            :disabled="!!companyId"
                            :error-messages="errors[0]"
                            v-model="model.lastname"
                        ></v-text-field>
                      </validation-provider>
                    </div>

                    <!-- login_name -->

                    <div class="flex-gt-sm-50 flex-100 px-2">
                      <validation-provider tag="div" name="login_name" rules="required" v-slot="{ errors }">
                        <v-text-field
                            :dark="compColor.isInDarkMode"
                            :color="compColor.primeColor"
                            :dense="denseFields"
                            :label="$t('COMPONENT_FORGOT_PASSWORD.USERNAME') + ' *'"
                            outlined
                            :hide-details="!errors || errors.length <= 0"
                            v-model="model.login_name"
                            :error-messages="errors[0]"
                            :disabled="!!companyId"
                        ></v-text-field>
                      </validation-provider>
                    </div>

                    <!-- password -->

                    <div class="flex-gt-sm-50 flex-100 px-2" v-if="!companyId">
                      <validation-provider tag="div" name="login_name" rules="required" v-slot="{ errors }">
                        <v-text-field
                            :dark="compColor.isInDarkMode"
                            :color="compColor.primeColor"
                            :dense="denseFields"
                            :label="$t('COMPONENT_ACCOUNT.PASSWORD') + ' *'"
                            prepend-inner-icon="security"
                            outlined
                            :hide-details="!errors || errors.length <= 0"
                            v-model="model.password"
                            :error-messages="errors[0]"
                            :disabled="!!companyId"
                            :clearable="false"
                            :append-icon="e1 ? 'visibility' : 'visibility_off'"
                            @click:append="() => (e1 = !e1)"
                            :type="e1 ? 'password' : 'text'"
                        ></v-text-field>
                      </validation-provider>
                    </div>

                    <div class="flex-gt-sm-100 flex-100 px-2">
                      <div class="pt-2 layout-row flex md12 sm12 xs12">
                        <label class="pr-2 pt-3" style="font-size: 16px;" :style="{color: compColor.primeColor}">{{ $t('COMPONENT_ACCOUNT.IS_ACTIVE') }}</label>
                        <v-checkbox :dark="compColor.isInDarkMode"
                                    :color="compColor.primeColor"
                                    class="mt-0 py-0"
                                    @change="changeActiveState"
                                    v-model="model.is_active">
                        </v-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </lx-expansion-panel-content>
            </lx-expansion-panel>
          </lx-expansion-panels>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash'

export default {
  name: "CompanyDetail",
  props: ['companyId', 'tabid'],
  data () {
    return {
      e1: true,
      loading: false,
      model: {},
      oldModel: {},
      panel: [0],
      error: {},
      errorDialog: false,
      authUserExists: null,
      localUserExists: null
    }
  },
  computed: {
    isMailInvalid () {
      return this.$refs.CompanyDetailForm.errors && this.$refs.CompanyDetailForm.errors.email && this.$refs.CompanyDetailForm.errors.email.length > 0
    }
  },
  created() {
    if (this.companyId) {
      this.getUserData()
    } else {
      this.model.is_active = true
      this.oldModel = lodash.cloneDeep(this.model)
    }
  },
  methods: {
    /**
     * Reset form input
     */
    clearForm(reset) {
      reset()
      this.model = lodash.cloneDeep(this.oldModel)

      // reset flags to hide alerts if exists
      this.authUserExists = null
      this.localUserExists = null
    },

    /**
     * Check if email already exists in auth and/or application
     */
    checkEmail () {
      if (!this.companyId && this.model.email) {
        this.loading = true

        this.$http.get('/companies/checkAuthUserExists/' + this.model.email)
            .then((res) => {
              if (res.data) {
                this.$set(this, 'authUserExists', res.data.authUser)
                this.$set(this, 'localUserExists', res.data.localUser)
              }
            })
            .catch(this.NotifyError)
            .finally(() => {
              this.loading = false
            })
      }
    },

    /**
     * Add user to application if auth-user already exists
     */
    addCompany () {
      if (!this.companyId && this.model.email) {
        this.loading = true

        this.$http.post('/companies/addExistingAuthUser', { email: this.model.email, userType: 'systemadmin' })
            .then((res) => {
              this.addTabToStore({
                routeName: 'CompanyDetails',
                routeParams: {companyId: res.data._id},
                options: {
                  headline: 'Firma ' + res.data.lastname + ', ' + res.data.firstname,
                }
              })
            })
            .catch(this.NotifyError)
            .finally(() => {
              this.loading = false
            })
      }
    },

    /**
     * Save new company to auth and users
     */
    saveCompanyData() {
      if (this.loading) return

      this.loading = true

      // create auth user
      const data = {
        email: this.model.email,
        login_name: this.model.login_name,
        password: this.model.password,
        is_active: this.model.is_active,
        firstname: this.model.firstname,
        lastname: this.model.lastname,
        user_type: 'systemadmin'
      }

      this.$http.post('/companies', data)
          .then((res) => {
            if (res.data && res.data.id) {
              // set new tab with saved company
              this.addTabToStore({
                routeName: 'CompanyDetails',
                routeParams: {companyId: res.data.id},
                options: {
                  headline: 'Firma ' + res.data.lastname + ', ' + res.data.firstname,
                }
              })

              // clear form of new patient
              this.clearForm(this.$refs.CompanyDetailForm.reset)
            }
          })
          .catch((error) => {
            this.populateFormError(this.$refs.CompanyDetailForm, error)
                .catch(this.NotifyError)
          })
          .finally(() => {
            this.loading = false
          })
    },

    /**
     * Get data of existing company
     */
    getUserData() {
      if (this.loading) return

      this.loading = true

      this.$http.get('/companies/id/' + this.companyId)
          .then(res => {
            if (res.data) {
              this.model = res.data
              this.oldModel = lodash.cloneDeep(this.model)
            }
            this.loading = false
          })
          .catch(this.NotifyError)
          .finally(() => {
            this.loading = false
          })
    },

    /**
     * Disable or enable already existing company for application
     */
    changeActiveState () {
      if (this.companyId) {
        // update is_active state for user
        this.loading = true

        this.$http.patch('/companies/changeActiveState', { user_id: this.companyId, is_active: this.model.is_active })
            .then((res) => {
              this.NotifySuccess(res, this.$t(this.model.is_active ? 'COMPONENT_ACCOUNT.USER_SUCCESSFULLY_ACTIVATED' : 'COMPONENT_ACCOUNT.USER_SUCCESSFULLY_DEACTIVATED'))
            })
            .catch(this.NotifyError)
            .finally(() => {
              this.loading = false
            })
      }
    }
  }
}
</script>
